<template>
  <div class="floating-toolbar">
<!--    <div class="toolbar-item customer-service" @click="openCustomerService">-->
<!--      <i class="el-icon-qrcode"></i>-->
<!--      <span class="tooltip">在线客服</span>-->
<!--    </div>-->
    <div class="toolbar-item phone-number">
      <img style="width: 35px;height: 35px; align-items: center;" src="/img/phone.svg">
      <span class="tooltip">13525947399</span>
    </div>
<!--    <div class="toolbar-item message" @click="showMessageNotice">-->
<!--      <i class="el-icon-edit-outline"></i>-->
<!--      <span class="tooltip">留言反馈</span>-->
<!--    </div>-->
    <div class="toolbar-item back-to-top" @click="scrollToTop" v-show="showBackToTop">
      <i class="el-icon-arrow-up"></i>
      <span class="tooltip">返回顶部</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'FloatingToolbar',
  data() {
    return {
      showBackToTop: false
    }
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll)
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll)
  },
  methods: {
    handleScroll() {
      this.showBackToTop = window.pageYOffset > 300
    },
    openCustomerService() {
      this.$message({
        message: '正在接入在线客服，请稍候...',
        type: 'success'
      })
      // 这里可以实现接入在线客服系统的逻辑
    },
    showMessageNotice() {
      this.$message({
        message: '功能正在完善中...',
        type: 'info'
      })
    },
    scrollToTop() {
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.floating-toolbar {
  position: fixed;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
  z-index: 999;
  
  .toolbar-item {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 50px;
    height: 50px;
    border-radius: 5px;
    background-color: #1ebec8;
    color: white;
    font-size: 20px;
    cursor: pointer;
    position: relative;
    transition: all 0.3s;
    
    &:hover {
      background-color: rgba(30, 190, 200, 0.1);
      
      .tooltip {
        opacity: 1;
        transform: translateX(0);
      }
    }
    
    .tooltip {
      position: absolute;
      right: 100%;
      top: 0;
      background-color: #1ebec8;
      color: white;
      padding: 0 15px;
      height: 50px;
      line-height: 50px;
      font-size: 14px;
      white-space: nowrap;
      border-top-left-radius: 25px;
      border-bottom-left-radius: 25px;
      opacity: 0;
      transform: translateX(20px);
      transition: all 0.3s;
      box-shadow: -2px 0 5px rgba(0, 0, 0, 0.1);
    }
    
    &.phone-number {
      position: relative;
      cursor: default;
    }
    
    &.back-to-top {
      background-color: rgba(30, 190, 200, 0.6);
    }
  }
}
</style>